<template>
  <div>
    <flexbox style="height: 100%; background-color: #FFFFFF; padding: 10px">
      <flexbox-item :span="4">
        <b-img class="mx-2" center :src="this.imageDomain(this.image)" alt="left image" style="max-height: 95px; max-width: 100px" />
      </flexbox-item>
      <flexbox-item>
        <flexbox orient="vertical">
          <flexbox-item class="pr-2" style="height: 40px;overflow: hidden;"><span>{{title}}</span></flexbox-item>
          <flexbox-item>
            <flexbox>
              <flexbox-item :span="4" style="color:red;">{{priceStr}}</flexbox-item>
              <!-- <flexbox-item :span="4"></flexbox-item> -->
              <flexbox-item :span="1" >
                <!-- x{{quantity}} -->
                <FITButton :disabled="parseInt(quantity)<=1" class="cardBtn mr-2" :iconOnly="true" faIcon="fa-minus" variant="outline-danger" @click.native="updatePackagesQuantity(-1)"></FITButton>
              </flexbox-item>
              <flexbox-item :span="1" >
                <!-- x{{quantity}} -->
                <span class="px-1 primaryColorText">{{quantity}}</span>
              </flexbox-item>
              <flexbox-item :span="1" >
                <!-- x{{quantity}} -->
                <FITButton @click.native="updatePackagesQuantity(1)" class="cardBtn" :iconOnly="true" faIcon="fa-plus" variant="outline-danger"></FITButton>
              </flexbox-item>
            </flexbox>
          </flexbox-item>
        </flexbox>
      </flexbox-item>
    </flexbox>
  </div>
</template>
<script type="text/javascript">
import {FITButton} from '@/components'
import { mapGetters } from 'vuex'
import { Flexbox, FlexboxItem } from 'vux'


export default {
  name: 'CartItem',
  components: {
    Flexbox,
    FlexboxItem,
    FITButton
  },
  props: {
    image: String,
    title: String,
    quantity: {
      type: [String, Number]
    },
    price: {
      type: [String, Number]
    },
    currency: String,
    packages:Object
  },
  data() {
    return {
      item:this.packages
    }
  },
  created() {

  },
  mounted() {},
  watch: {},
  computed: {
    ...mapGetters([
      'getExchangePrice',
    ]),
    priceStr() {
        return this.currency+ ' ' + this.price;

    }
  },
  methods: {
    imageDomain(image) {
      return this.$store.getters.getImageUrl(image);
    },
    updatePackagesQuantity(delta){
      let obj = JSON.parse(JSON.stringify(this.item))
      obj.quantity += delta;
      console.log(obj)
      this.$store.dispatch("updatePackagesInCart",obj)
    }
  },
}

</script>
<style type="text/css">
.headerContainer {
  /*  margin-top: 44px;
*/
}

</style>



// WEBPACK FOOTER //
// src/Package/components/CartItem.vue